	<template>
		<input class="calculator__input" :class="classes" v-model="m" :id="id" :aria-label="label" type="text">  
	</template>

	<script>
	export default {
		name: "InputTextElement",
		props: {
			label: String,
			id: String,
			classes: Object,
			value: String
		},
		computed: { 
			m : {
				get() {
					return this.value;
				}, 
				set(value) {
					this.$emit('input', value);
					this.$emit('change', value);
					this.$emit('blur', value);
				}
			}
		}
	};
	</script>